import { HttpClient } from '@angular/common/http';
export class Map {
    public Created: Date;
    public Updated: Date;
    public Bbox: [number, number, number, number];
    public Screenshot: string;
    public Path: string;
    public MapId: string;
    public Name: string;
    public isEdit: boolean = false;
    public Config: string;
    public currentState: any;
    public Description: string;
    public constructor(private http: HttpClient) {
    }

    public returnInfo() {
        this.isEdit = false;
        this.Created = this.currentState.Created;
        this.Updated = this.currentState.Updated;
        this.Bbox = this.currentState.Bbox;
        this.Screenshot = this.currentState.Screenshot;
        this.Path = this.currentState.Path;
        this.Name = this.currentState.Name;
        this.Config = this.currentState.Config;
        this.Description = this.currentState.Description;
    }

    public saveCurrentInfo() {
        this.isEdit = true;
        this.currentState = {
            Created: this.Created,
            Updated: this.Updated,
            Bbox: this.Bbox,
            Screenshot: this.Screenshot,
            Path: this.Path,
            Name: this.Name,
            Config: this.Config,
            Description: this.Description
        };
        console.log(this.currentState);

    }

    public saveInfo() {
        this.isEdit = false;
        this.http.post(remoteApiHost + 'api/admin/updateMapInfo', {Created: this.Created,
            Updated: new Date(),
            Bbox: this.Bbox,
            Screenshot: this.Screenshot,
            Path: this.Path,
            MapId: this.MapId,
            Name: this.Name,
            Config: this.Config,
            Description: this.Description}).subscribe((data: any) => {
            });
    }

}



// WEBPACK FOOTER //
// ./src/app/admin/map-editor/map.ts